import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { doctoralCommitteeMembershipOptions } from '@/module/Nomen/DoctoralCommitteeMembership/model/DoctoralCommitteeMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type DoctoralCommitteeMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function DoctoralCommitteeMembershipSelectControl<T extends FieldValues>(
  props: DoctoralCommitteeMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(doctoralCommitteeMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
